export enum ErrorType {
  NONE,
  GENERALNETWORKERROR,
  CORSNETWORKERROR,
}
